import type { PermissionEnum } from 'fleet-data-model';
import Store from '~/store/Store';

export const getUserPermissions = (): PermissionEnum[] => {
  return Store.getState().authentication.permissions;
};
